import { motion } from "framer-motion";

export default function IFSubMenu({ textAlign = "left", text1 = "", text2 = "", as = "h4" }) {
    const isLeft = textAlign === "left";
    const Heading1 = as === "h1" ? "h1" : "h4";
    const Heading2 = as === "h1" ? "h2" : "h5";

    return (
        <div
            className={`flex flex-col gap-1 mb-5 relative ${isLeft ? "items-start text-left" : "items-end text-right"
                }`}
        >
            <div
                className={`flex items-center gap-3 ${isLeft ? "flex-row" : "flex-row-reverse"
                    }`}
            >
                {/* Glowing Vertical Pill (Linear) */}
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    whileInView={{ height: "100%", opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, ease: "linear" }}
                    className="w-1 min-h-[42px] rounded-full bg-gradient-to-b from-pink to-ungu"
                />

                <div className="flex flex-col">
                    {text1 && (
                        <Heading1 className="text-xl sm:text-2xl lg:text-3xl font-extrabold tracking-tight text-white leading-tight">
                            {text1.toUpperCase()}
                        </Heading1>
                    )}
                    {text2 && (
                        <Heading2 className="text-xl sm:text-2xl lg:text-3xl font-extrabold tracking-tight leading-tight bg-gradient-to-r from-pink to-[#ff6b8b] bg-clip-text text-transparent">
                            {text2.toUpperCase()}
                        </Heading2>
                    )}
                </div>
            </div>
        </div>
    );
}

export { IFSubMenu as IF_SubMenu };
